var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { isNil } from 'lodash-es';
import { hideMenuProvider } from '../../utilities/picker.tools';
import { currentDateKey, keyToDate } from '../date/date-picker-calculations';
import styles from '../sds-date-picker.lit.scss';
import '../shared/calendar/sds-calendar.lit';
import { pairLessOrEqual, tripletLessOrEqual } from '../shared/comparators';
import { monthRangeMapper, weekHoverStateMapper, weekRangeMapper, yearRangeMapper, } from '../shared/mapper-utils';
import '../shared/month-view/month-view.lit';
import { getMonth, getYear } from '../shared/utils';
import { displayWeekDate, keyToWeek, localDateToLocalWeek, monthWithMostDaysInWeek, weekToDays, weekToKey, } from './week-picker-calculations';
import { translate } from '../../utilities/translate';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-week-range` is a web component designed for selecting a range of weeks within a specified time frame.
 * It allows users to easily pick a start and end week, facilitating tasks such as scheduling,
 * event planning, and other time-sensitive applications.
 *
 * The component features customizable attributes, including options for placeholders,
 * currently selected dates, hints, and error handling.
 *
 * ### Attributes
 * - `placeholder`: The placeholder text for the input fields. Defaults to `'sds.week_picker_range.placeholder'`.
 * - `start-week`: The starting week of the selected range in `{year}/{week}` format. Defaults to `undefined`.
 * - `end-week`: The ending week of the selected range in `{year}/{week}` format. Defaults to `undefined`.
 * - `locale`: The locale for the week range picker. Defaults to `'en'`.
 * - `current-date`: The current date in `{year}/{week}` format. Defaults to the value returned by `currentDateKey()`.
 * - `hint`: A hint to provide context for the selection. Defaults to an empty string.
 * - `disabled`: A boolean indicating if the picker is disabled. Defaults to `false`.
 * - `invalid`: A boolean indicating if the selection is invalid. Defaults to `false`.
 * - `error-message`: The error message to display if validation fails. Defaults to an empty string.
 *
 * @tag sds-week-range
 */
let SdsWeekRange = (() => {
    var _SdsWeekRange_placeholder_accessor_storage, _SdsWeekRange_startWeek_accessor_storage, _SdsWeekRange_endWeek_accessor_storage, _SdsWeekRange_locale_accessor_storage, _SdsWeekRange_currentDate_accessor_storage, _SdsWeekRange_hint_accessor_storage, _SdsWeekRange_disabled_accessor_storage, _SdsWeekRange_invalid_accessor_storage, _SdsWeekRange_errorMessage_accessor_storage, _SdsWeekRange__contextMenu_accessor_storage, _SdsWeekRange__inputDate_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-week-range')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _startWeek_decorators;
    let _startWeek_initializers = [];
    let _startWeek_extraInitializers = [];
    let _endWeek_decorators;
    let _endWeek_initializers = [];
    let _endWeek_extraInitializers = [];
    let _locale_decorators;
    let _locale_initializers = [];
    let _locale_extraInitializers = [];
    let _currentDate_decorators;
    let _currentDate_initializers = [];
    let _currentDate_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __inputDate_decorators;
    let __inputDate_initializers = [];
    let __inputDate_extraInitializers = [];
    var SdsWeekRange = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsWeekRange_placeholder_accessor_storage.set(this, __runInitializers(this, _placeholder_initializers, 'sds.week_picker_range.placeholder'));
            _SdsWeekRange_startWeek_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _startWeek_initializers, void 0)));
            _SdsWeekRange_endWeek_accessor_storage.set(this, (__runInitializers(this, _startWeek_extraInitializers), __runInitializers(this, _endWeek_initializers, void 0)));
            _SdsWeekRange_locale_accessor_storage.set(this, (__runInitializers(this, _endWeek_extraInitializers), __runInitializers(this, _locale_initializers, 'en')));
            _SdsWeekRange_currentDate_accessor_storage.set(this, (__runInitializers(this, _locale_extraInitializers), __runInitializers(this, _currentDate_initializers, currentDateKey())));
            _SdsWeekRange_hint_accessor_storage.set(this, (__runInitializers(this, _currentDate_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsWeekRange_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsWeekRange_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsWeekRange_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsWeekRange__contextMenu_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsWeekRange__inputDate_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __inputDate_initializers, void 0)));
            this._sdsCalendar = __runInitializers(this, __inputDate_extraInitializers);
            this.hideMenu = hideMenuProvider(this);
            this.mouseOutHandler = () => {
                var _a;
                if (this.endWeek === undefined) {
                    (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setWeekStateMapper(weekRangeMapper(this.startWeek, undefined));
                }
            };
            this.showContextMenu = () => {
                var _a, _b;
                if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                    this.resetPage();
                    this._inputDate.focused = true;
                    const trigger = this._inputDate.getInput();
                    (_b = this._contextMenu) === null || _b === void 0 ? void 0 : _b.show(trigger);
                    this.setMappers();
                }
            };
            this.handleCleared = () => {
                var _a;
                this._inputDate.focused = Boolean((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened);
                this.updateValue();
                this.updatePageIndex();
            };
            this.handleDatePicked = (event) => {
                this.updateValue(localDateToLocalWeek(event.detail.date));
            };
            this.handleWeekPicked = (event) => {
                this.updateValue(event.detail.week);
            };
            this.handleMonthSelect = (event) => {
                const [year, _] = event.detail.month;
                if (isNil(this.startWeek) || !(isNil(this.startWeek) || isNil(this.endWeek))) {
                    this._preselectedStartYear = year;
                    this._preselectedEndYear = undefined;
                    this._preselectedStartMonth = event.detail.month;
                    this._preselectedEndMonth = undefined;
                }
                else {
                    this._preselectedEndYear = year;
                    this._preselectedEndMonth = event.detail.month;
                }
                this.setMappers();
            };
            this.handleYearSelect = (event) => {
                if (isNil(this.startWeek) || !(isNil(this.startWeek) || isNil(this.endWeek))) {
                    this._preselectedStartYear = event.detail.year;
                    this._preselectedEndYear = undefined;
                }
                else {
                    this._preselectedEndYear = event.detail.year;
                }
                this.setMappers();
            };
            this.handleHover = (event) => {
                var _a, _b;
                if (this.startWeek !== undefined &&
                    this.endWeek === undefined &&
                    event.detail.hoveredItem) {
                    const hoveredWeek = event.detail.type === 'week'
                        ? event.detail.hoveredItem
                        : localDateToLocalWeek(event.detail.hoveredItem);
                    (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setWeekStateMapper(weekHoverStateMapper(this.startWeek, hoveredWeek));
                    (_b = this._sdsCalendar) === null || _b === void 0 ? void 0 : _b.setDateStateMapper(weekDateHoverStateMapper(weekToDays(this.startWeek), weekToDays(hoveredWeek)));
                }
                else if (event.detail.hoveredItem === undefined) {
                    this.setMappers();
                }
            };
        }
        /**
         * Sets the placeholder text for the week range input fields, providing a hint to users when no week is selected.
         * This attribute helps guide users to understand the expected input or purpose of the week selection.
         *
         * This placeholder text enhances accessibility and user experience by indicating
         * what the user is expected to select.
         *
         * @attr {string} placeholder - Placeholder text for the week range input fields.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsWeekRange_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsWeekRange_placeholder_accessor_storage, value, "f"); }
        /**
         * Specifies the starting week of the selected range in the format `{year}/{week}`.
         * This attribute allows users to define the beginning of the week range they wish to select.
         *
         * Setting this attribute updates the internal state of the component, ensuring that
         * the selection reflects the correct start week.
         *
         * @attr {string} start-week - The starting week of the selected range in `{year}/{week}` format.
         */
        get startWeek() { return __classPrivateFieldGet(this, _SdsWeekRange_startWeek_accessor_storage, "f"); }
        set startWeek(value) { __classPrivateFieldSet(this, _SdsWeekRange_startWeek_accessor_storage, value, "f"); }
        /**
         * Specifies the ending week of the selected range in the format `{year}/{week}`.
         * This attribute allows users to define the end of the week range they wish to select.
         *
         * Setting this attribute updates the internal state of the component, ensuring that
         * the selection reflects the correct end week.
         *
         * @attr {string} end-week - The ending week of the selected range in `{year}/{week}` format.
         */
        get endWeek() { return __classPrivateFieldGet(this, _SdsWeekRange_endWeek_accessor_storage, "f"); }
        set endWeek(value) { __classPrivateFieldSet(this, _SdsWeekRange_endWeek_accessor_storage, value, "f"); }
        /**
         * Sets the locale for the week range picker, affecting the language and formatting used within the component.
         * This attribute enhances the user experience by allowing localization based on user preferences.
         *
         * The default locale is set to `'en'`, but it can be changed to accommodate different languages.
         *
         * @attr {string} locale - The locale for the week range picker.
         */
        get locale() { return __classPrivateFieldGet(this, _SdsWeekRange_locale_accessor_storage, "f"); }
        set locale(value) { __classPrivateFieldSet(this, _SdsWeekRange_locale_accessor_storage, value, "f"); }
        /**
         * Represents the current date in `{year}/{week}` format, initialized using `currentDateKey()`.
         * This attribute is used to provide context within the week range selection, ensuring that users
         * have a reference point when making their selection.
         *
         * @attr {string} current-date - The current date in `{year}/{week}` format.
         */
        get currentDate() { return __classPrivateFieldGet(this, _SdsWeekRange_currentDate_accessor_storage, "f"); }
        set currentDate(value) { __classPrivateFieldSet(this, _SdsWeekRange_currentDate_accessor_storage, value, "f"); }
        /**
         * Sets a hint for this week range picker, providing additional context to users.
         * This attribute enhances user experience by clarifying the selection purpose.
         *
         * @attr {string} hint - A hint to provide context for the selection.
         */
        get hint() { return __classPrivateFieldGet(this, _SdsWeekRange_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsWeekRange_hint_accessor_storage, value, "f"); }
        /**
         * True if this week range picker is disabled, preventing user interaction.
         * This attribute is useful for indicating when the picker should be non-functional.
         *
         * @attr {boolean} disabled - Indicates if the picker is disabled.
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsWeekRange_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsWeekRange_disabled_accessor_storage, value, "f"); }
        /**
         * True if this week range picker is invalid, often used for validation purposes.
         * This attribute indicates to users that the current selection is not acceptable.
         *
         * @attr {boolean} invalid - Indicates if the selection is invalid.
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsWeekRange_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsWeekRange_invalid_accessor_storage, value, "f"); }
        /**
         * The error message of this week range picker, displayed when validation fails.
         * This attribute provides feedback to users, guiding them to correct their input.
         *
         * @attr {string} error-message - The error message to display if validation fails.
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsWeekRange_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsWeekRange_errorMessage_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsWeekRange__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsWeekRange__contextMenu_accessor_storage, value, "f"); }
        get _inputDate() { return __classPrivateFieldGet(this, _SdsWeekRange__inputDate_accessor_storage, "f"); }
        set _inputDate(value) { __classPrivateFieldSet(this, _SdsWeekRange__inputDate_accessor_storage, value, "f"); }
        render() {
            return html `
            <sds-input-date
                id="input-date"
                placeholder="${translate(this.placeholder)}"
                readonly
                ?disabled="${this.disabled}"
                hint="${this.hint}"
                error-message="${this.errorMessage}"
                ?invalid="${this.invalid}"
                @click="${this.showContextMenu}"
                @sds.input-date.cleared="${this.handleCleared}"
            ></sds-input-date>
            <sds-context-menu id="context-menu">
                <sds-calendar
                    currentDay="${this.currentDate}"
                    tabindex="0"
                    week-numbers
                    per-week-hover
                    @mouseout="${this.mouseOutHandler}"
                    @sds.calendar.select="${this.handleDatePicked}"
                    @sds.calendar.week.select="${this.handleWeekPicked}"
                    @sds.calendar.hover="${this.handleHover}"
                    @sds.calendar.month.select="${this.handleMonthSelect}"
                    @sds.calendar.year.select="${this.handleYearSelect}"
                >
                </sds-calendar>
            </sds-context-menu>
        `;
        }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('mouseup', this.hideMenu);
        }
        disconnectedCallback() {
            document.removeEventListener('mouseup', this.hideMenu);
            this.hideContextMenu();
            super.disconnectedCallback();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        willUpdate(_changedProperties) {
            if (_changedProperties.has('startWeek') || _changedProperties.has('endWeek')) {
                this.setMappers();
            }
            if (_changedProperties.has('endWeek') && this.endWeek !== undefined) {
                this.hideContextMenu();
            }
        }
        updated(_changedProperties) {
            if (_changedProperties.has('startWeek') || _changedProperties.has('endWeek')) {
                this.updateInput();
            }
        }
        async firstUpdated() {
            this.initCmContentContainer(); // init container ASAP
            await this.updateComplete;
            this.updatePageIndex();
        }
        setMappers() {
            var _a, _b, _c, _d, _e, _f;
            (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setWeekStateMapper(weekRangeMapper(this.startWeek, this.endWeek));
            const startWeekDays = this.startWeek ? weekToDays(this.startWeek) : undefined;
            const endWeekDays = this.endWeek ? weekToDays(this.endWeek) : undefined;
            (_b = this._sdsCalendar) === null || _b === void 0 ? void 0 : _b.setDateStateMapper(weekDaysRangeMapper(startWeekDays, endWeekDays));
            const startDay = startWeekDays ? startWeekDays[0] : undefined;
            const endDay = endWeekDays ? endWeekDays[6] : undefined;
            let startYear = (_c = this._preselectedStartYear) !== null && _c !== void 0 ? _c : getYear(startDay);
            let endYear;
            if (!isNil(endDay) && isNil(this._preselectedStartYear)) {
                // case when endDate is set by user
                endYear = getYear(endDay);
            }
            else {
                endYear = this._preselectedEndYear;
            }
            if (!isNil(startYear) && !isNil(endYear) && startYear > endYear) {
                [startYear, endYear] = [endYear, startYear];
            }
            (_d = this._sdsCalendar) === null || _d === void 0 ? void 0 : _d.setYearStateMapper(yearRangeMapper(startYear, endYear));
            let startMonth = (_e = this._preselectedStartMonth) !== null && _e !== void 0 ? _e : getMonth(startDay);
            let endMonth;
            if (!isNil(endDay) && isNil(this._preselectedStartMonth)) {
                // case when endDate is set by user
                endMonth = getMonth(endDay);
            }
            else {
                endMonth = this._preselectedEndMonth;
            }
            if (!isNil(startMonth) && !isNil(endMonth) && pairLessOrEqual(endMonth, startMonth)) {
                [startMonth, endMonth] = [endMonth, startMonth];
            }
            (_f = this._sdsCalendar) === null || _f === void 0 ? void 0 : _f.setMonthStateMapper(monthRangeMapper(startMonth, endMonth));
        }
        resetPage() {
            var _a;
            (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.navigateTo('SelectDate');
            this.updatePageIndex();
        }
        initCmContentContainer() {
            var _a;
            const sdsCalendar = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-calendar');
            if (sdsCalendar) {
                this._sdsCalendar = sdsCalendar;
            }
        }
        updatePageIndex() {
            var _a, _b;
            if (this.startWeek) {
                (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setPageIndex(this.startWeek[0], monthWithMostDaysInWeek(weekToDays(this.startWeek)));
            }
            else if (this.currentDate) {
                const [year, month] = keyToDate(this.currentDate);
                (_b = this._sdsCalendar) === null || _b === void 0 ? void 0 : _b.setPageIndex(year, month);
            }
        }
        hideContextMenu() {
            var _a;
            if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                this._contextMenu.hide();
            }
        }
        updateValue(week) {
            if (week === undefined) {
                this.startWeek = undefined;
                this.endWeek = undefined;
                this.resetPreselectedValues();
                this.dispatchChange();
            }
            else if (this.startWeek === undefined || this.endWeek !== undefined) {
                this.startWeek = week;
                this.endWeek = undefined;
            }
            else {
                this.endWeek = week;
                if (pairLessOrEqual(this.endWeek, this.startWeek)) {
                    [this.startWeek, this.endWeek] = [this.endWeek, this.startWeek];
                }
                this.resetPreselectedValues();
                this.dispatchChange();
            }
        }
        resetPreselectedValues() {
            this._preselectedStartYear = undefined;
            this._preselectedEndYear = undefined;
            this._preselectedStartMonth = undefined;
            this._preselectedEndMonth = undefined;
            this.setMappers();
        }
        updateInput() {
            let inputValue = '';
            if (this.startWeek !== undefined) {
                inputValue = displayWeekDate(this.startWeek, this.locale);
            }
            if (this.endWeek !== undefined) {
                inputValue += ' - ' + displayWeekDate(this.endWeek, this.locale);
            }
            this._inputDate.value = inputValue;
        }
        dispatchChange() {
            this.dispatchEvent(new CustomEvent(SdsWeekRange.WEEK_RANGE_CHANGE_EVENT, {
                detail: {
                    startWeek: this.startWeek ? weekToKey(...this.startWeek) : undefined,
                    endWeek: this.endWeek ? weekToKey(...this.endWeek) : undefined,
                },
            }));
        }
    };
    _SdsWeekRange_placeholder_accessor_storage = new WeakMap();
    _SdsWeekRange_startWeek_accessor_storage = new WeakMap();
    _SdsWeekRange_endWeek_accessor_storage = new WeakMap();
    _SdsWeekRange_locale_accessor_storage = new WeakMap();
    _SdsWeekRange_currentDate_accessor_storage = new WeakMap();
    _SdsWeekRange_hint_accessor_storage = new WeakMap();
    _SdsWeekRange_disabled_accessor_storage = new WeakMap();
    _SdsWeekRange_invalid_accessor_storage = new WeakMap();
    _SdsWeekRange_errorMessage_accessor_storage = new WeakMap();
    _SdsWeekRange__contextMenu_accessor_storage = new WeakMap();
    _SdsWeekRange__inputDate_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsWeekRange");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _placeholder_decorators = [property({ type: String })];
        _startWeek_decorators = [property({
                type: String,
                converter: keyToWeek,
                attribute: 'start-week',
            })];
        _endWeek_decorators = [property({
                type: String,
                converter: keyToWeek,
                attribute: 'end-week',
            })];
        _locale_decorators = [property()];
        _currentDate_decorators = [property({ attribute: 'current-date' })];
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        __contextMenu_decorators = [query('#context-menu')];
        __inputDate_decorators = [query('#input-date')];
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _startWeek_decorators, { kind: "accessor", name: "startWeek", static: false, private: false, access: { has: obj => "startWeek" in obj, get: obj => obj.startWeek, set: (obj, value) => { obj.startWeek = value; } }, metadata: _metadata }, _startWeek_initializers, _startWeek_extraInitializers);
        __esDecorate(_classThis, null, _endWeek_decorators, { kind: "accessor", name: "endWeek", static: false, private: false, access: { has: obj => "endWeek" in obj, get: obj => obj.endWeek, set: (obj, value) => { obj.endWeek = value; } }, metadata: _metadata }, _endWeek_initializers, _endWeek_extraInitializers);
        __esDecorate(_classThis, null, _locale_decorators, { kind: "accessor", name: "locale", static: false, private: false, access: { has: obj => "locale" in obj, get: obj => obj.locale, set: (obj, value) => { obj.locale = value; } }, metadata: _metadata }, _locale_initializers, _locale_extraInitializers);
        __esDecorate(_classThis, null, _currentDate_decorators, { kind: "accessor", name: "currentDate", static: false, private: false, access: { has: obj => "currentDate" in obj, get: obj => obj.currentDate, set: (obj, value) => { obj.currentDate = value; } }, metadata: _metadata }, _currentDate_initializers, _currentDate_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __inputDate_decorators, { kind: "accessor", name: "_inputDate", static: false, private: false, access: { has: obj => "_inputDate" in obj, get: obj => obj._inputDate, set: (obj, value) => { obj._inputDate = value; } }, metadata: _metadata }, __inputDate_initializers, __inputDate_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsWeekRange = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.WEEK_RANGE_CHANGE_EVENT = 'sds.week-range.changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsWeekRange = _classThis;
})();
export { SdsWeekRange };
function weekDaysRangeMapper(startWeek, endWeek) {
    if (startWeek !== undefined && endWeek !== undefined) {
        return key => tripletLessOrEqual(startWeek[0], key) && tripletLessOrEqual(key, endWeek[6])
            ? 'range'
            : 'none';
    }
    else if (startWeek !== undefined || endWeek !== undefined) {
        const selectWeek = (startWeek !== undefined ? startWeek : endWeek);
        return key => tripletLessOrEqual(selectWeek[0], key) && tripletLessOrEqual(key, selectWeek[6])
            ? 'sub-selected'
            : 'none';
    }
    else {
        return () => 'none';
    }
}
export function weekDateHoverStateMapper(start, hover) {
    return key => {
        if (tripletLessOrEqual(start[0], key) && tripletLessOrEqual(key, start[6])) {
            return 'sub-selected';
        }
        else if ((tripletLessOrEqual(start[6], key) && tripletLessOrEqual(key, hover[0])) ||
            (tripletLessOrEqual(hover[6], key) && tripletLessOrEqual(key, start[0]))) {
            return 'range-hover';
        }
        else {
            return 'none';
        }
    };
}
